import React from 'react';
import PropTypes from 'prop-types';
import { Alert } from 'react-bootstrap';
import { I18n } from './../i18n';
import Onelog from './onelog';
import PageChanger from './page_changer';
import SearchBar from './searchBar';

class Changelog extends React.Component {
  constructor (props) {
    super(props);
    this.state = {
      filteredLogs: [],
      currentPage: 1,
      pageSize: 5
    };
    this.handlePages = this.handlePages.bind(this);
    this.handleFilterChange = this.handleFilterChange.bind(this);
  }

  componentDidMount () {
    this.setState({
      filteredLogs: this.props.changelog
    });
  }

  handlePages (index) {
    this.setState({
      currentPage: index
    });
  }

  handleFilterChange (filteredLogs) {
    this.setState({
      filteredLogs: filteredLogs,
      currentPage: 1
    });
  }

  render () {
    return (
      <div>
        <div className="col-md-auto ml-2 mb-3">
          <h1 className="mb-0">{I18n.t('changelogs.title')}</h1>
          <h5 className="page-title-secondary text-muted">
            {I18n.t('changelogs.showing', { count: this.state.filteredLogs.length, total: this.props.changelog.length })}
          </h5>
        </div>
        <SearchBar
          changelogs={this.props.changelog}
          onFilterChange={this.handleFilterChange}
        />
        {this.state.filteredLogs.length === 0 && (
          <Alert color="danger">{I18n.t('changelogs.empty')}</Alert>
        )}
        {this.state.filteredLogs.slice(
          this.state.currentPage * this.state.pageSize - this.state.pageSize,
          this.state.currentPage * this.state.pageSize
        ).map(log => (
          <Onelog key={log.id} log={log} />
        ))}
        {this.state.filteredLogs.length > this.state.pageSize && (
          <PageChanger
            handlePages={this.handlePages}
            pages={Math.ceil(
              this.state.filteredLogs.length / this.state.pageSize
            )}
            currentPage={this.state.currentPage}
          />
        )}
      </div>
    );
  }
}

Changelog.propTypes = {
  changelog: PropTypes.array
};

export default Changelog;
